import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

/**
 * Download dropdown component that downloads the list data in CSV or XLS format.
 */
export function ExportButton({
  onExport,
  disabled,
}: {
  onExport: (format: 'csv' | 'xls') => Promise<unknown>;
  disabled?: boolean;
}) {
  const { $t } = useIntl();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isExporting, setIsExporting] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExport = async (format: 'csv' | 'xls') => {
    handleClose();
    setIsExporting(true);

    try {
      await onExport(format);
    } catch (error) {
      console.error('Error downloading data:', error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="secondary"
        startIcon={<FileDownloadOutlinedIcon />}
        endIcon={<ArrowDropDownIcon />}
        onClick={handleClick}
        loading={isExporting}
        loadingPosition="start"
        disabled={disabled}
      >
        {$t({
          id: 'common.actions.export',
          defaultMessage: 'Exportar',
        })}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => handleExport('csv')}>
          {$t({
            id: 'common.actions.exportAsCsv',
            defaultMessage: 'Exportar como CSV',
          })}
        </MenuItem>
        <MenuItem onClick={() => handleExport('xls')}>
          {$t({
            id: 'common.actions.exportAsXls',
            defaultMessage: 'Exportar como XLS',
          })}
        </MenuItem>
      </Menu>
    </>
  );
}
